import React, { lazy } from 'react'
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import AccessibleNavigationAnnouncer from "./components/AccessibleNavigationAnnouncer";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";

const Layout = lazy(() => import("./containers/Layout"));
const Login = lazy(() => import("./pages/Login"));
const Page404 = lazy(() => import("./pages/404"));
const CreateAccount = lazy(() => import("./pages/CreateAccount"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const ResetPassword = lazy(() => import("./pages/ResetPassword"));

function App() {
  const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

  return (
    <>
      <GoogleReCaptchaProvider
        reCaptchaKey={recaptchaSiteKey}
        language="pt-BR"
        useRecaptchaNet={false}
        useEnterprise={false}
        scriptProps={{
          async: true,
          defer: true,
          appendTo: "head",
        }}
      >
        <Router>
          <AccessibleNavigationAnnouncer />
          <Switch>
            <Route path="/login" component={Login} />
            <Route path="/create-account" component={CreateAccount} />
            <Route path="/forgot-password" component={ForgotPassword} />
            <Route path="/reset-password" component={ResetPassword} />

            <ProtectedRoute path="/app" component={Layout} />
            <Redirect exact from="/" to="/login" />
            <Route component={Page404} />
          </Switch>
        </Router>
      </GoogleReCaptchaProvider>
    </>
  );
}

export default App
